import axios from 'axios';

const SESSION_KEY = 'vibesplit_admin_token';
export const clearAdminSession = () => {
  sessionStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem('vibesplit_admin_session');
};
// The server verifies signatures and role. This expiry check only avoids
// rendering a signed-in shell for expired or malformed browser storage.
export const getAdminSession = () => {
  const token = localStorage.getItem(SESSION_KEY) || sessionStorage.getItem(SESSION_KEY);
  if (!token) return null;
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload));
    if (typeof exp !== 'number' || exp * 1000 <= Date.now()) throw new Error('Expired');
    localStorage.setItem(SESSION_KEY, token);
    sessionStorage.removeItem(SESSION_KEY);
    return token;
  } catch {
    clearAdminSession();
    return null;
  }
};
export const saveAdminSession = (token: string) => {
  localStorage.setItem(SESSION_KEY, token);
  sessionStorage.removeItem(SESSION_KEY);
};

const adminApi = axios.create();
adminApi.interceptors.request.use(request => {
  const token = getAdminSession();
  if (token) request.headers.Authorization = `Bearer ${token}`;
  return request;
});
adminApi.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401 && !error.config?.url?.endsWith('/admin/verify-password')) {
    clearAdminSession();
    window.dispatchEvent(new Event('vibesplit-admin-expired'));
  }
  return Promise.reject(error);
});
export default adminApi;
